import { createAction, props } from '@ngrx/store';

export const documentAll = createAction('DOCUMENT_ALL', props<{items: any}>());
export const documentList = createAction('DOCUMENT_LIST', props<{items: any}>());
export const documentCreate = createAction('DOCUMENT_CREATE', props<{item: any}>());
export const documentUpdate = createAction('DOCUMENT_UPDATE', props<{item: any}>());
export const documentDelete = createAction('DOCUMENT_DELETE', props<{item: any}>());
